/**
 * Switch modules
 */
export * from './switch';
